
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13558",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13558",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1203",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10145",
  "foundations-components": "static-1.8798",
  "foundations-components-legacy": "static-1.1823",
  "foundations-theming": "static-1.4998",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8547",
  "hub-http-shared-msw-handlers": "static-1.10956",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11996",
  "I18n": "static-7.1716",
  "jasmine-runner": "static-1.6961",
  "marketplace-discovery-studio-lib": "static-1.957",
  "marketplace-storefront-base": "static-1.13621",
  "quartz": "static-1.7698",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17243",
  "reactive-variable-buffer-atom": "static-1.3355",
  "reporting-testing-lib": "static-1.11434",
  "reselect": "static-3.18",
  "settings-ui-lib": "static-1.13036",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7898",
  "ui-addon-i18n": "static-1.11653",
  "ui-addon-react-router-dom": "static-1.10033",
  "unified-auth": "static-1.1319",
  "unified-auth-core-lib": "static-1.1601",
  "usage-tracker": "static-1.7826",
  "usage-tracker-core": "static-1.7676",
  "customer-data-property-utils": "static-1.8561",
  "hub-http": "static-1.6710",
  "integrations-lib": "static-1.17497",
  "marketplace-ui-common": "static-1.21097",
  "marketplace-ui-install": "static-1.1083",
  "property-management-iframe": "static-1.14536",
  "quartz-config": "static-1.1476",
  "quartz-core": "static-1.6917",
  "quartz-routing": "static-1.1128",
  "quick-fetch": "static-1.4247",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5170",
  "ts-schema": "static-1.4411",
  "ui-universal-auth": "static-1.9805",
  "UIComponents": "static-3.8942",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven": "static-3.6411",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3975",
  "quartz-webpack": "static-1.3922",
  "bend-plugin-quartz-routing": "static-1.776",
  "ai-components-ui-library": "static-1.10076",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5395",
  "pulse": "static-1.1160",
  "react-codemirror": "static-1.11148",
  "ui-extensions-preview-lib": "static-1.1041",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5067",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2714",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9936",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.112",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5682",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3177",
  "ui-fonts": "static-1.1258",
  "ui-images": "static-2.1284",
  "bend-plugin-foundations-theming": "static-1.3481",
  "foundations-theming-base": "static-1.3983",
  "stylex": "static-1.48",
  "HeadJS": "static-2.830",
  "hs-test-utils-bend-plugin": "static-1.3658",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4810",
  "ui-addon-video-player": "static-1.9127",
  "ai-rendering-library": "static-1.11466",
  "chirp-fetch": "static-1.2409",
  "connections-embed-lib": "static-1.1803",
  "copilot-toolkit": "static-1.12210",
  "feedback-loader": "static-1.30106",
  "laboratory-lib": "static-3.7655",
  "marketplace-embed": "static-1.23257",
  "marketplace-ui-details": "static-1.10992",
  "marketplace-ui-reviews": "static-1.21052",
  "marketplace-ui-tracking": "static-1.15267",
  "sanitize-text": "static-1.8666",
  "usage-tracker-multi": "static-1.6240",
  "usage-tracker-session-replay": "static-1.5512",
  "beacon-keepalive-queue": "static-1.207",
  "quartz-head": "static-1.1363",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5097",
  "immer": "static-1.107",
  "immerable": "static-1.4647",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2867",
  "reporting-data": "static-1.69501",
  "cssUtils": "static-1.1130",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10713",
  "react-dnd-compat": "static-1.5112",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10878",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7816",
  "icons": "static-2.710",
  "marketplace-ui-apps-core": "static-1.19629",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.5003",
  "foundations-components-test-utils": "static-1.6281",
  "quartz-i18n": "static-1.1373",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.794",
  "ads-unified-auth-lib": "static-1.2193",
  "ai-mcp-auth-lib": "static-1.56",
  "custom-vendor-connection-lib": "static-1.369",
  "gemini-settings-lib": "static-1.9840",
  "google-sheets-integration-lib": "static-1.1390",
  "microsoft-drive-auth-lib": "static-1.577",
  "slack-ui-library": "static-1.10909",
  "surveymonkey-integration-lib": "static-1.900",
  "fsm": "static-1.4266",
  "customer-data-objects": "static-1.8219",
  "property-translator": "static-1.5885",
  "hs-locale-management": "static-1.419",
  "frontend-preferences-client": "static-1.8427",
  "hs-promise-utils": "static-1.6096",
  "hubspot-apollo-client": "static-1.5387",
  "integrations-error-boundary-lib": "static-1.14912",
  "integrations-tracking-lib": "static-1.6132",
  "native-integrations-shared-strings": "static-1.8266",
  "sanitize": "static-1.4974",
  "superstore": "static-1.5262",
  "ui-shepherd-react": "static-3.10790",
  "ai-settings-ui-library": "static-1.8637",
  "hub-http-janus": "static-1.914",
  "hubspotter-http": "static-1.4991",
  "immutable-less": "static-1.5159",
  "marketplace-ui-client-types": "static-1.18504",
  "nav-meta": "static-1.30868",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18568",
  "ui-product-approvals-common": "static-1.1709",
  "ai-studio-lib": "static-1.12833",
  "hubspot-prosemirror": "static-1.19340",
  "integrations-reconnect-lib": "static-1.776",
  "ui-addon-iframeable": "static-1.9585",
  "ui-addon-integrations-directory-panel": "static-2.8458",
  "ui-product-approvals": "static-1.29814",
  "ui-tool-access": "static-1.10666",
  "inbound-db-properties-service-client": "static-1.4168",
  "property-management-common": "static-1.6824",
  "opentelemetry-fe-types": "static-1.300",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.675",
  "quartz-auth": "static-1.1373",
  "quartz-test": "static-1.1373",
  "quartz-tracking": "static-1.1077",
  "trellis-components": "static-1.3196",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.580",
  "HubStyle": "static-2.12303",
  "bender-build-tools": "static-1.3622",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24077",
  "ContentUtils": "static-1.69549",
  "customer-data-objects-ui-components": "static-1.13540",
  "sassPrefix": "static-1.391",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2058",
  "bend-plugin-pulse": "static-1.663",
  "event-emitter": "static-1.1465",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5933",
  "magpie-types": "static-1.5393",
  "stylex-utils": "static-1.183",
  "trellis-theming": "static-1.1528",
  "avatar-components": "static-1.2995",
  "breeze-engine-core": "static-1.1558",
  "breeze-engine-lib": "static-1.2280",
  "breeze-onboarding-components": "static-1.1138",
  "customer-data-filters-ui": "static-1.41461",
  "customer-data-reference-ui-components": "static-1.13679",
  "data-integrations-breeze": "static-1.393",
  "embedded-academy-lib": "static-1.16108",
  "ExportDialog": "static-6.10880",
  "global-styles-ai-lib": "static-1.562",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.960",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42476",
  "reporting-snowflake": "static-1.58117",
  "reporting-ui-components": "static-2.66770",
  "reporting-visualizations": "static-1.61575",
  "trial-components-library": "static-1.14436",
  "ui-addon-teams": "static-1.22044",
  "upgrade-components-lib": "static-1.764",
  "navigation-components": "static-1.19231",
  "nest": "static-1.742",
  "simple-logging-lib": "static-1.3555",
  "nudge-client-utils": "static-1.3468",
  "fail-safe": "static-1.454",
  "app-governance-lib": "static-1.2795",
  "developer-experience-shared-components": "static-1.11049",
  "purchase-motions-components": "static-1.6674",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10867",
  "usage-tracker-anonymous": "static-1.6243",
  "usage-tracker-public": "static-1.7637",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3791",
  "persist-promise": "static-1.4215",
  "reference-resolvers": "static-1.8692",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4423",
  "hubspot-apollo-cache": "static-1.846",
  "universal-page-editor-lib": "static-1.3522",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3877",
  "merchandise-lib": "static-1.288",
  "onboarding-scopes": "static-1.6957",
  "ui-addon-draggable": "static-3.5259",
  "content-assistance-lib": "static-1.8467",
  "content-media-capture": "static-1.5844",
  "customer-data-ui-utilities": "static-1.10340",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24890",
  "growth-payments-core": "static-1.26559",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3389",
  "payment-link-components": "static-1.24522",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20604",
  "ui-addon-emoji-picker": "static-1.10371",
  "ui-business-units-lib": "static-1.9602",
  "video-components-external": "static-1.12500",
  "video-data-lib": "static-1.36158",
  "navigation-messaging": "static-1.8558",
  "collaboration-sidebar": "static-1.59126",
  "trellis-ext-dnd": "static-1.589",
  "crm-component-utils": "static-1.40276",
  "crm-properties-common-lib": "static-1.6403",
  "customer-data-properties": "static-1.53163",
  "external-options-client-types": "static-1.4455",
  "hs-resources": "static-1.694",
  "property-value-citations": "static-1.3777",
  "reference-resolvers-lite": "static-1.8619",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10954",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5319",
  "content-icons-ui": "static-1.2489",
  "atom": "static-1.5580",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1228",
  "trellis-migration-context": "static-1.86",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1258",
  "breeze-artifacts-sdk": "static-1.1093",
  "breeze-assistant-components": "static-1.2565",
  "getting-started-shared-tasks": "static-1.19620",
  "onboarding-journeys-lib": "static-1.1300",
  "conversations-skeleton-state": "static-1.7622",
  "crm-message-bus": "static-1.44172",
  "customer-data-filters-ui-msw-helpers": "static-1.23896",
  "events-data-lib": "static-1.755",
  "FormUrlGenerator": "static-2.5219",
  "framework-builder-read-service-client": "static-1.4352",
  "multi-account-reference-resolvers": "static-1.1522",
  "onboarding-tours": "static-1.17437",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14821",
  "segments-client-types": "static-1.12292",
  "academy-common-lib": "static-1.15569",
  "dashboard-lib": "static-1.83385",
  "hubspot-prosemirror-plugins": "static-1.19332",
  "reporting-plugins": "static-1.11057",
  "share-with-third-party-component-lib": "static-1.9218",
  "ui-addon-draggable-compat": "static-2.4766",
  "ui-asset-management-lib": "static-1.11611",
  "user-context": "static-1.5563",
  "reporting-reports": "static-1.69177",
  "hubs-service-types": "static-1.1771",
  "purchase-motions-api": "static-1.6677",
  "salesImages": "static-1.764",
  "signup-constants": "static-1.20013",
  "nudge-custom-function-registry": "static-1.3225",
  "nudge-renderer-utils": "static-1.3544",
  "whisper-core-api": "static-1.7683",
  "bend-plugin-fail-safe": "static-1.405",
  "framework-listing-lib": "static-2.29873",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31810",
  "apps-service-types": "static-1.4115",
  "oauth-service-types": "static-1.4644",
  "signup-ui-url-generator": "static-2.8542",
  "onboarding-tours-client": "static-1.5652",
  "one-click-checkout": "static-1.786",
  "platform-infra-nav-components": "static-1.8018",
  "subscription-experience-data-types": "static-1.15480",
  "crm-record-cards-client": "static-1.138",
  "crm-record-cards-service-types": "static-1.3878",
  "framework-data-schema-resolvers": "static-1.7402",
  "location-customization-utils-lib": "static-1.10484",
  "redux-thunk": "static-2.86",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29613",
  "content-media-composition-data-lib": "static-1.13648",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4934",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3981",
  "seat-types-lib": "static-1.1104",
  "ui-addon-opt": "static-4.8928",
  "commerce-tours-lib": "static-1.6907",
  "growth-onboarding-reliability": "static-1.5592",
  "sales-checkout-service-client": "static-1.4030",
  "data-token-picker": "static-1.17184",
  "FileManagerLib": "static-1.40530",
  "content-media-compositions": "static-2.17655",
  "media-bridge-lib": "static-1.19688",
  "chatspot-widget-iframe": "static-1.24068",
  "collaboration-sidebar-common": "static-1.3923",
  "marketing-platform-lib": "static-1.7412",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38109",
  "crm-actions": "static-1.6896",
  "crm-cards-sdk": "static-1.45109",
  "customer-data-properties-shared-msw-handlers": "static-1.10283",
  "customer-data-tracking": "static-1.7376",
  "calling-global-api": "static-1.66307",
  "calling-internal-common": "static-1.31828",
  "calling-lifecycle-internal": "static-1.67689",
  "calling-lifecycle-messages": "static-1.59981",
  "commerce-products-lib": "static-1.10992",
  "conditional-properties-service-client": "static-1.4130",
  "crm-index-visualization-core": "static-1.4800",
  "crm-links": "static-1.6821",
  "crm-pipelines-api-client-types": "static-1.4460",
  "data-agent-utils": "static-1.980",
  "formula-editor": "static-1.15053",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4531",
  "meetings-icalendar-utils-lib": "static-1.1140",
  "multi-currency-client-types": "static-1.4025",
  "object-builder-ui-client": "static-1.50120",
  "pipeline-validation-client-types": "static-1.4300",
  "react-tinymce": "static-1.56327",
  "smart-data-capture-core": "static-1.546",
  "tiered-pricing": "static-1.2336",
  "tinymce-config": "static-2.55453",
  "tinymce-plugins": "static-1.58567",
  "tinymce-themes": "static-1.57423",
  "topics-actions-lib": "static-1.693",
  "trellis-ext-i18n": "static-1.1433",
  "ui-addon-form-validation": "static-1.11352",
  "zustand": "static-1.91",
  "fdsr-migration-layer": "static-1.521",
  "breeze-sharing-core": "static-1.53",
  "restore-request-side-panel-lib": "static-1.2103",
  "growth-data-modal": "static-1.6176",
  "growth-onboarding-confetti": "static-1.3566",
  "growth-onboarding-next-action-utils": "static-1.3041",
  "onboarding-tours-utils": "static-1.1504",
  "ui-shepherd-tracker": "static-1.8171",
  "crm-index-associations-lib": "static-1.6957",
  "academy-service-client": "static-1.4200",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40389",
  "SafeStorage": "static-1.4903",
  "video-embed": "static-1.36992",
  "wootric-nps": "static-1.7314",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25301",
  "viral-links-lib": "static-1.7587",
  "campaign-roi-lib": "static-1.10902",
  "campaigns-utils-lib": "static-1.3760",
  "ui-addon-calendars": "static-2.5876",
  "nested-table": "static-1.731",
  "timezone-utils": "static-2.5734",
  "getting-started-shared-tasks-store": "static-1.18738",
  "customer-data-views-management": "static-1.26411",
  "framework-data-table": "static-2.12889",
  "nudge-custom-ui-functions": "static-1.1783",
  "switchboard-lib": "static-1.746",
  "access-check-ui-lib": "static-1.1946",
  "app-users-service-client": "static-1.6124",
  "app-users-service-types": "static-1.5532",
  "mini-checkout-client": "static-1.27881",
  "onboarding-utils": "static-1.5882",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "ui-coaching-tips-shared-config": "static-1.29598",
  "checkout-sdk": "static-3.24724",
  "payment-method-components": "static-1.7348",
  "touchless-buying-components": "static-1.6592",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.896",
  "framework-data-schema-quick-fetch": "static-1.7307",
  "growth-onboarding-feedback-components": "static-1.7089",
  "audio-components": "static-1.6613",
  "FileManagerImages": "static-1.38041",
  "video-components": "static-1.14502",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20548",
  "commerce-shared-components-lib": "static-1.19634",
  "commerce-tools-ui-lib": "static-1.11383",
  "crm_data": "static-4.93274",
  "crm-activity-creator-data": "static-1.47819",
  "crm-fe-perf": "static-1.23407",
  "universal-record-utils-lib": "static-1.2432",
  "calling-error-reporting": "static-1.31835",
  "shared-worker-versioning": "static-1.11548",
  "calling-usage-tracker": "static-1.7049",
  "voice-sms-access-library": "static-1.2552",
  "commerce-permissions": "static-1.1291",
  "products-iframe-lib": "static-1.8974",
  "products-ui-components-shared-msw-handlers": "static-1.11338",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11039",
  "sales-views-client-types": "static-1.4766",
  "data-agent-kit": "static-1.967",
  "enrichment-settings-lib": "static-1.325",
  "policy-lib": "static-1.7310",
  "bark-lib": "static-1.17039",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3536",
  "interframe": "static-3.5247",
  "tinymce-data": "static-1.41538",
  "ui-addon-sales-email": "static-1.5711",
  "layout-dnd-components": "static-1.13273",
  "layout-dnd-utils": "static-1.12248",
  "ui-brand-identity-lib": "static-1.17021",
  "NamespacedHubStyle": "static-2.9384",
  "onboarding-data-sync-lib": "static-1.2882",
  "growth-onboarding-next-action-components": "static-1.3069",
  "user-context-client": "static-1.5017",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5022",
  "outpost": "static-1.4638",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22407",
  "sales-email-signature-service-client": "static-1.4352",
  "copilot-messaging": "static-1.2460",
  "ts-utils-lib": "static-1.660",
  "crm-export-dialog": "static-1.6785",
  "crm-index-ui-shimmer": "static-1.3055",
  "crm-view-components": "static-1.1575",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7846",
  "tasks-actions-lib": "static-1.488",
  "InboxConnectUtils": "static-4.15897",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.888",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4496",
  "company-details-components": "static-1.6715",
  "react-performance-metrics-lib": "static-1.1058",
  "pricing-pages-ui-components": "static-1.16687",
  "quote-checkout-service-types": "static-1.3967",
  "social-insights-client-types": "static-1.22983",
  "utility-belt": "static-1.3042",
  "payments-enrollment-embed-lib": "static-1.24313",
  "stripe-embedded-components": "static-1.8293",
  "customer-data-rte": "static-1.33954",
  "cv-backend-services": "static-1.1612",
  "growth-onboarding-empty-states": "static-1.6584",
  "payments-post-enroll-local-storage-lib": "static-1.5610",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39222",
  "crm_universal": "static-1.22769",
  "customer-data-email": "static-1.18690",
  "meetings-rte-lib": "static-1.591",
  "universal-associations-select": "static-1.11604",
  "crm-object-search-query-utilities": "static-1.10512",
  "calling-orchestration-schema": "static-1.37329",
  "react-reducer-toolkit": "static-1.16720",
  "ContentData": "static-1.69624",
  "layout-data-lib": "static-1.10573",
  "meetings-connect-utils-lib": "static-1.8124",
  "company-details-service-types": "static-1.4449",
  "segments-query-core": "static-1.1936",
  "pricing-pages-api": "static-1.16552",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29207",
  "sequences-lib": "static-1.8828",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4096",
  "meetings-core": "static-1.813",
  "advanced-menus-core": "static-1.15866",
  "advanced-menus-lib": "static-1.12607",
  "ui-memberships-settings-lib": "static-1.35264",
  "sequences-client-types-lib": "static-1.8685",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15865",
  "simple-menus-lib": "static-1.17382"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13558",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1203",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10145",
  "foundations-components": "/foundations-components/static-1.8798",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1823",
  "foundations-theming": "/foundations-theming/static-1.4998",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8547",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10956",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11996",
  "I18n": "/I18n/static-7.1716",
  "jasmine-runner": "/jasmine-runner/static-1.6961",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.957",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13621",
  "quartz": "/quartz/static-1.7698",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17243",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3355",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11434",
  "reselect": "/reselect/static-3.18",
  "settings-ui-lib": "/settings-ui-lib/static-1.13036",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7898",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11653",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10033",
  "unified-auth": "/unified-auth/static-1.1319",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1601",
  "usage-tracker": "/usage-tracker/static-1.7826",
  "usage-tracker-core": "/usage-tracker-core/static-1.7676",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8561",
  "hub-http": "/hub-http/static-1.6710",
  "integrations-lib": "/integrations-lib/static-1.17497",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21097",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1083",
  "property-management-iframe": "/property-management-iframe/static-1.14536",
  "quartz-config": "/quartz-config/static-1.1476",
  "quartz-core": "/quartz-core/static-1.6917",
  "quartz-routing": "/quartz-routing/static-1.1128",
  "quick-fetch": "/quick-fetch/static-1.4247",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5170",
  "ts-schema": "/ts-schema/static-1.4411",
  "ui-universal-auth": "/ui-universal-auth/static-1.9805",
  "UIComponents": "/UIComponents/static-3.8942",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven": "/raven/static-3.6411",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3975",
  "quartz-webpack": "/quartz-webpack/static-1.3922",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.776",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10076",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5395",
  "pulse": "/pulse/static-1.1160",
  "react-codemirror": "/react-codemirror/static-1.11148",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1041",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5067",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2714",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9936",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.112",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5682",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3177",
  "ui-fonts": "/ui-fonts/static-1.1258",
  "ui-images": "/ui-images/static-2.1284",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3481",
  "foundations-theming-base": "/foundations-theming-base/static-1.3983",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.830",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3658",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4810",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9127",
  "ai-rendering-library": "/ai-rendering-library/static-1.11466",
  "chirp-fetch": "/chirp-fetch/static-1.2409",
  "connections-embed-lib": "/connections-embed-lib/static-1.1803",
  "copilot-toolkit": "/copilot-toolkit/static-1.12210",
  "feedback-loader": "/feedback-loader/static-1.30106",
  "laboratory-lib": "/laboratory-lib/static-3.7655",
  "marketplace-embed": "/marketplace-embed/static-1.23257",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10992",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21052",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15267",
  "sanitize-text": "/sanitize-text/static-1.8666",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6240",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5512",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.207",
  "quartz-head": "/quartz-head/static-1.1363",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5097",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4647",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2867",
  "reporting-data": "/reporting-data/static-1.69501",
  "cssUtils": "/cssUtils/static-1.1130",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10713",
  "react-dnd-compat": "/react-dnd-compat/static-1.5112",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10878",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7816",
  "icons": "/icons/static-2.710",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19629",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.5003",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6281",
  "quartz-i18n": "/quartz-i18n/static-1.1373",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.794",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2193",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.56",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.369",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9840",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1390",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.577",
  "slack-ui-library": "/slack-ui-library/static-1.10909",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.900",
  "fsm": "/fsm/static-1.4266",
  "customer-data-objects": "/customer-data-objects/static-1.8219",
  "property-translator": "/property-translator/static-1.5885",
  "hs-locale-management": "/hs-locale-management/static-1.419",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8427",
  "hs-promise-utils": "/hs-promise-utils/static-1.6096",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5387",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14912",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6132",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8266",
  "sanitize": "/sanitize/static-1.4974",
  "superstore": "/superstore/static-1.5262",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10790",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8637",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hubspotter-http": "/hubspotter-http/static-1.4991",
  "immutable-less": "/immutable-less/static-1.5159",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18504",
  "nav-meta": "/nav-meta/static-1.30868",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18568",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1709",
  "ai-studio-lib": "/ai-studio-lib/static-1.12833",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19340",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.776",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9585",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8458",
  "ui-product-approvals": "/ui-product-approvals/static-1.29814",
  "ui-tool-access": "/ui-tool-access/static-1.10666",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4168",
  "property-management-common": "/property-management-common/static-1.6824",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.300",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.675",
  "quartz-auth": "/quartz-auth/static-1.1373",
  "quartz-test": "/quartz-test/static-1.1373",
  "quartz-tracking": "/quartz-tracking/static-1.1077",
  "trellis-components": "/trellis-components/static-1.3196",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.580",
  "HubStyle": "/HubStyle/static-2.12303",
  "bender-build-tools": "/bender-build-tools/static-1.3622",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24077",
  "ContentUtils": "/ContentUtils/static-1.69549",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13540",
  "sassPrefix": "/sassPrefix/static-1.391",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2058",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.663",
  "event-emitter": "/event-emitter/static-1.1465",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5933",
  "magpie-types": "/magpie-types/static-1.5393",
  "stylex-utils": "/stylex-utils/static-1.183",
  "trellis-theming": "/trellis-theming/static-1.1528",
  "avatar-components": "/avatar-components/static-1.2995",
  "breeze-engine-core": "/breeze-engine-core/static-1.1558",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2280",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1138",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41461",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13679",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.393",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16108",
  "ExportDialog": "/ExportDialog/static-6.10880",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.562",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.960",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42476",
  "reporting-snowflake": "/reporting-snowflake/static-1.58117",
  "reporting-ui-components": "/reporting-ui-components/static-2.66770",
  "reporting-visualizations": "/reporting-visualizations/static-1.61575",
  "trial-components-library": "/trial-components-library/static-1.14436",
  "ui-addon-teams": "/ui-addon-teams/static-1.22044",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.764",
  "navigation-components": "/navigation-components/static-1.19231",
  "nest": "/nest/static-1.742",
  "simple-logging-lib": "/simple-logging-lib/static-1.3555",
  "nudge-client-utils": "/nudge-client-utils/static-1.3468",
  "fail-safe": "/fail-safe/static-1.454",
  "app-governance-lib": "/app-governance-lib/static-1.2795",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11049",
  "purchase-motions-components": "/purchase-motions-components/static-1.6674",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10867",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6243",
  "usage-tracker-public": "/usage-tracker-public/static-1.7637",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3791",
  "persist-promise": "/persist-promise/static-1.4215",
  "reference-resolvers": "/reference-resolvers/static-1.8692",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4423",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.846",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3522",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3877",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "onboarding-scopes": "/onboarding-scopes/static-1.6957",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5259",
  "content-assistance-lib": "/content-assistance-lib/static-1.8467",
  "content-media-capture": "/content-media-capture/static-1.5844",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10340",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24890",
  "growth-payments-core": "/growth-payments-core/static-1.26559",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3389",
  "payment-link-components": "/payment-link-components/static-1.24522",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20604",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10371",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9602",
  "video-components-external": "/video-components-external/static-1.12500",
  "video-data-lib": "/video-data-lib/static-1.36158",
  "navigation-messaging": "/navigation-messaging/static-1.8558",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59126",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.589",
  "crm-component-utils": "/crm-component-utils/static-1.40276",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6403",
  "customer-data-properties": "/customer-data-properties/static-1.53163",
  "external-options-client-types": "/external-options-client-types/static-1.4455",
  "hs-resources": "/hs-resources/static-1.694",
  "property-value-citations": "/property-value-citations/static-1.3777",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8619",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10954",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5319",
  "content-icons-ui": "/content-icons-ui/static-1.2489",
  "atom": "/atom/static-1.5580",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1228",
  "trellis-migration-context": "/trellis-migration-context/static-1.86",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1258",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1093",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2565",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19620",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1300",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7622",
  "crm-message-bus": "/crm-message-bus/static-1.44172",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23896",
  "events-data-lib": "/events-data-lib/static-1.755",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5219",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4352",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1522",
  "onboarding-tours": "/onboarding-tours/static-1.17437",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14821",
  "segments-client-types": "/segments-client-types/static-1.12292",
  "academy-common-lib": "/academy-common-lib/static-1.15569",
  "dashboard-lib": "/dashboard-lib/static-1.83385",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19332",
  "reporting-plugins": "/reporting-plugins/static-1.11057",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9218",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4766",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11611",
  "user-context": "/user-context/static-1.5563",
  "reporting-reports": "/reporting-reports/static-1.69177",
  "hubs-service-types": "/hubs-service-types/static-1.1771",
  "purchase-motions-api": "/purchase-motions-api/static-1.6677",
  "salesImages": "/salesImages/static-1.764",
  "signup-constants": "/signup-constants/static-1.20013",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3225",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3544",
  "whisper-core-api": "/whisper-core-api/static-1.7683",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.405",
  "framework-listing-lib": "/framework-listing-lib/static-2.29873",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31810",
  "apps-service-types": "/apps-service-types/static-1.4115",
  "oauth-service-types": "/oauth-service-types/static-1.4644",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8542",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5652",
  "one-click-checkout": "/one-click-checkout/static-1.786",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8018",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15480",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.138",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3878",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7402",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10484",
  "redux-thunk": "/redux-thunk/static-2.86",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29613",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13648",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4934",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3981",
  "seat-types-lib": "/seat-types-lib/static-1.1104",
  "ui-addon-opt": "/ui-addon-opt/static-4.8928",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6907",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5592",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4030",
  "data-token-picker": "/data-token-picker/static-1.17184",
  "FileManagerLib": "/FileManagerLib/static-1.40530",
  "content-media-compositions": "/content-media-compositions/static-2.17655",
  "media-bridge-lib": "/media-bridge-lib/static-1.19688",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24068",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3923",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7412",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38109",
  "crm-actions": "/crm-actions/static-1.6896",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45109",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10283",
  "customer-data-tracking": "/customer-data-tracking/static-1.7376",
  "calling-global-api": "/calling-global-api/static-1.66307",
  "calling-internal-common": "/calling-internal-common/static-1.31828",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67689",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59981",
  "commerce-products-lib": "/commerce-products-lib/static-1.10992",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4130",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4800",
  "crm-links": "/crm-links/static-1.6821",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4460",
  "data-agent-utils": "/data-agent-utils/static-1.980",
  "formula-editor": "/formula-editor/static-1.15053",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4531",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1140",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4025",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50120",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4300",
  "react-tinymce": "/react-tinymce/static-1.56327",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.546",
  "tiered-pricing": "/tiered-pricing/static-1.2336",
  "tinymce-config": "/tinymce-config/static-2.55453",
  "tinymce-plugins": "/tinymce-plugins/static-1.58567",
  "tinymce-themes": "/tinymce-themes/static-1.57423",
  "topics-actions-lib": "/topics-actions-lib/static-1.693",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1433",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "zustand": "/zustand/static-1.91",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.521",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.53",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2103",
  "growth-data-modal": "/growth-data-modal/static-1.6176",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3566",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3041",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1504",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8171",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6957",
  "academy-service-client": "/academy-service-client/static-1.4200",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40389",
  "SafeStorage": "/SafeStorage/static-1.4903",
  "video-embed": "/video-embed/static-1.36992",
  "wootric-nps": "/wootric-nps/static-1.7314",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25301",
  "viral-links-lib": "/viral-links-lib/static-1.7587",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10902",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3760",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5876",
  "nested-table": "/nested-table/static-1.731",
  "timezone-utils": "/timezone-utils/static-2.5734",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18738",
  "customer-data-views-management": "/customer-data-views-management/static-1.26411",
  "framework-data-table": "/framework-data-table/static-2.12889",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1783",
  "switchboard-lib": "/switchboard-lib/static-1.746",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1946",
  "app-users-service-client": "/app-users-service-client/static-1.6124",
  "app-users-service-types": "/app-users-service-types/static-1.5532",
  "mini-checkout-client": "/mini-checkout-client/static-1.27881",
  "onboarding-utils": "/onboarding-utils/static-1.5882",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29598",
  "checkout-sdk": "/checkout-sdk/static-3.24724",
  "payment-method-components": "/payment-method-components/static-1.7348",
  "touchless-buying-components": "/touchless-buying-components/static-1.6592",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.896",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7307",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7089",
  "audio-components": "/audio-components/static-1.6613",
  "FileManagerImages": "/FileManagerImages/static-1.38041",
  "video-components": "/video-components/static-1.14502",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20548",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19634",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11383",
  "crm_data": "/crm_data/static-4.93274",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47819",
  "crm-fe-perf": "/crm-fe-perf/static-1.23407",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2432",
  "calling-error-reporting": "/calling-error-reporting/static-1.31835",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11548",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7049",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2552",
  "commerce-permissions": "/commerce-permissions/static-1.1291",
  "products-iframe-lib": "/products-iframe-lib/static-1.8974",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11338",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11039",
  "sales-views-client-types": "/sales-views-client-types/static-1.4766",
  "data-agent-kit": "/data-agent-kit/static-1.967",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.325",
  "policy-lib": "/policy-lib/static-1.7310",
  "bark-lib": "/bark-lib/static-1.17039",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3536",
  "interframe": "/interframe/static-3.5247",
  "tinymce-data": "/tinymce-data/static-1.41538",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5711",
  "layout-dnd-components": "/layout-dnd-components/static-1.13273",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12248",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17021",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9384",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2882",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3069",
  "user-context-client": "/user-context-client/static-1.5017",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5022",
  "outpost": "/outpost/static-1.4638",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22407",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4352",
  "copilot-messaging": "/copilot-messaging/static-1.2460",
  "ts-utils-lib": "/ts-utils-lib/static-1.660",
  "crm-export-dialog": "/crm-export-dialog/static-1.6785",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3055",
  "crm-view-components": "/crm-view-components/static-1.1575",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7846",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.488",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15897",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.888",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4496",
  "company-details-components": "/company-details-components/static-1.6715",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1058",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16687",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3967",
  "social-insights-client-types": "/social-insights-client-types/static-1.22983",
  "utility-belt": "/utility-belt/static-1.3042",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24313",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8293",
  "customer-data-rte": "/customer-data-rte/static-1.33954",
  "cv-backend-services": "/cv-backend-services/static-1.1612",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6584",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5610",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39222",
  "crm_universal": "/crm_universal/static-1.22769",
  "customer-data-email": "/customer-data-email/static-1.18690",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.591",
  "universal-associations-select": "/universal-associations-select/static-1.11604",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10512",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37329",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16720",
  "ContentData": "/ContentData/static-1.69624",
  "layout-data-lib": "/layout-data-lib/static-1.10573",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8124",
  "company-details-service-types": "/company-details-service-types/static-1.4449",
  "segments-query-core": "/segments-query-core/static-1.1936",
  "pricing-pages-api": "/pricing-pages-api/static-1.16552",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29207",
  "sequences-lib": "/sequences-lib/static-1.8828",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4096",
  "meetings-core": "/meetings-core/static-1.813",
  "advanced-menus-core": "/advanced-menus-core/static-1.15866",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12607",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35264",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8685",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15865",
  "simple-menus-lib": "/simple-menus-lib/static-1.17382"
}
};
